import React from 'react';
import { UDSkeletonText } from 'ud-ui/components/skeleton';
import { TemplateListCatalog } from 'modules/template-editor/ui/pages/styles';
import { CATALOG_CAPTION_GAP, CATALOG_CARD_WIDTH, CATALOG_OWNER_GAP, CATALOG_PREVIEW_HEIGHT } from './catalog-card-metrics';

/**
 * Сколько карточек рисовать, пока каталога нет: три ряда по четыре колонки — больше, чем видно на экране.
 * На тестовом стенде в каталоге 17 шаблонов, так что сетка всё равно уходит под сгиб.
 */
export const CATALOG_SKELETON_CARD_COUNT = 12;

/**
 * Заглушка сетки «Готовых шаблонов» на время загрузки каталога (IMGM-1618).
 *
 * Та же сетка `TemplateListCatalog` и те же размеры карточки из `catalog-card-metrics.ts`, что у `TemplateItem`.
 * Ширины плашек — по реальным данным: название — около 12 символов `caption-1`, автор — «ImGame»
 * (`.claude/docs/skeleton-kit.md`).
 */
const CatalogGridSkeleton = () => (
  <TemplateListCatalog className="self-stretch" data-testid="catalog-grid-skeleton" aria-busy="true">
    {Array.from({ length: CATALOG_SKELETON_CARD_COUNT }, (_, index) => (
      <div key={index} className="flex flex-col" aria-hidden>
        <div className="skeleton-block" style={{ width: CATALOG_CARD_WIDTH, height: CATALOG_PREVIEW_HEIGHT }} />
        <div className="flex items-center justify-between" style={{ marginTop: CATALOG_CAPTION_GAP }}>
          <UDSkeletonText type="caption-1" className="w-24" />
          <UDSkeletonText type="tip" className="w-14" />
        </div>
        <div style={{ marginTop: CATALOG_OWNER_GAP }}>
          <UDSkeletonText type="tip" className="w-12" />
        </div>
      </div>
    ))}
  </TemplateListCatalog>
);

export default CatalogGridSkeleton;
